import { useEffect, useState } from "react";
import { xosoService } from "@/services/xosoService";

export default function useProvinces() {
  const [provinces, setProvinces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const data = await xosoService.getProvinces();
      if (!cancelled) {
        setProvinces(data);
        setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const byRegion = {
    MN: provinces.filter((p) => p.region === "MN").sort((a, b) => a.name.localeCompare(b.name, "vi")),
    MT: provinces.filter((p) => p.region === "MT").sort((a, b) => a.name.localeCompare(b.name, "vi")),
    MB: provinces.filter((p) => p.region === "MB").sort((a, b) => a.name.localeCompare(b.name, "vi")),
  };

  return { provinces, byRegion, loading };
}
